{
  "name": "factoriolab",
  "description": "Angular-based calculator for the game Factorio",
  "version": "0.0.0",
  "private": true,
  "contributors": [
    "Doug Broad (https://github.com/dcbroad3)"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/factoriolab/factoriolab.git"
  },
  "homepage": "https://factoriolab.github.io",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-stats": "ng build --stats-json",
    "test": "ng test",
    "test-build": "ng test --no-watch --no-progress --browsers=ChromeHeadless",
    "analyze": "webpack-bundle-analyzer dist/stats.json",
    "lint": "ng lint",
    "lint-build": "ng lint --max-warnings 0",
    "prettier": "prettier --check .",
    "factorio-api": "ts-node -r tsconfig-paths/register scripts/factorio-api.ts",
    "postfactorio-api": "prettier --write \"scripts/factorio.models.ts\"",
    "factorio-prep": "ts-node -r tsconfig-paths/register scripts/factorio-prep.ts",
    "factorio-dump": "scripts\\factorio-dump.bat",
    "factorio-dump:mac": "scripts/factorio-dump.sh",
    "factorio-build": "ts-node -r tsconfig-paths/register scripts/factorio-build.ts",
    "factorio-update": "ts-node -r tsconfig-paths/register scripts/factorio-update.ts",
    "calculate-color": "ts-node -r tsconfig-paths/register scripts/calculate-color.ts",
    "minify-data": "ts-node -r tsconfig-paths/register scripts/minify-data.ts",
    "update-hash": "ts-node -r tsconfig-paths/register scripts/update-hash.ts",
    "generate-hash": "ts-node -r tsconfig-paths/register scripts/generate-hash.ts"
  },
  "dependencies": {
    "@angular/animations": "^18.1.0",
    "@angular/cdk": "^18.1.0",
    "@angular/common": "^18.1.0",
    "@angular/compiler": "^18.1.0",
    "@angular/core": "^18.1.0",
    "@angular/forms": "^18.1.0",
    "@angular/platform-browser": "^18.1.0",
    "@angular/platform-browser-dynamic": "^18.1.0",
    "@angular/router": "^18.1.0",
    "@angular/service-worker": "^18.1.0",
    "@fortawesome/fontawesome-free": "^6.5.1",
    "@ngrx/effects": "^18.0.1",
    "@ngrx/store": "^18.0.1",
    "@ngrx/store-devtools": "^18.0.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sideway/formula": "^3.0.1",
    "bootstrap": "^5.3.1",
    "d3": "^7.8.5",
    "elkjs": "^0.8.2",
    "file-saver": "^2.0.5",
    "glpk-ts": "^0.0.11",
    "ngx-google-analytics": "^14.0.1",
    "pako": "^2.1.0",
    "primeicons": "^7.0.0",
    "primeng": "^17.18.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.6.2",
    "vis-data": "^7.1.6",
    "vis-network": "^9.1.8",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.1801.0",
    "@angular-devkit/build-angular": "~18.1.0",
    "@angular-eslint/builder": "~18.1.0",
    "@angular-eslint/eslint-plugin": "~18.1.0",
    "@angular-eslint/eslint-plugin-template": "~18.1.0",
    "@angular-eslint/schematics": "~18.1.0",
    "@angular-eslint/template-parser": "~18.1.0",
    "@angular/cli": "^18.1.0",
    "@angular/compiler-cli": "^18.1.0",
    "@angular/language-service": "^18.1.0",
    "@semantic-release/exec": "^6.0.3",
    "@types/d3": "^7.4.3",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "^4.3.1",
    "@types/node": "^18.14.6",
    "@types/pako": "^2.0.0",
    "@types/sharp": "0.31.1",
    "@types/spritesmith": "^3.4.1",
    "@typescript-eslint/eslint-plugin": "~7.17.0",
    "@typescript-eslint/parser": "~7.17.0",
    "eslint": "^8.56.0",
    "fast-average-color-node": "^2.6.0",
    "handlebars": "^4.7.8",
    "jasmine-core": "~5.1.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.0",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ngrx-store-freeze": "~0.2.4",
    "prettier": "^3.2.4",
    "semantic-release": "^23.0.7",
    "semantic-release-discord-bot": "^1.1.0",
    "sharp": "0.31.3",
    "spritesmith": "^3.4.1",
    "ts-node": "^10.9.1",
    "tsconfig-paths": "^4.2.0",
    "typescript": "~5.5.3",
    "webpack-bundle-analyzer": "^4.9.0"
  },
  "browser": {
    "crypto": false,
    "fs": false,
    "path": false
  },
  "release": {
    "branches": [
      "main"
    ],
    "plugins": [
      [
        "@semantic-release/commit-analyzer",
        {
          "preset": "angular",
          "releaseRules": [
            {
              "type": "data",
              "release": "patch"
            }
          ]
        }
      ],
      "@semantic-release/release-notes-generator",
      "@semantic-release/github",
      "@semantic-release/npm",
      [
        "semantic-release-discord-bot",
        {
          "notifications": [
            {
              "branch": "main"
            }
          ]
        }
      ],
      [
        "@semantic-release/exec",
        {
          "successCmd": "echo \"DEPLOY=true\" >> \"$GITHUB_ENV\""
        }
      ]
    ]
  }
}
